import React, { useState, useEffect } from "react";
import Button from "Trackalyze/Button";

const CheckBox = React.forwardRef(({
  checked: propsChecked,
  callBack,
  disabled,
  className,
  onClick,
  ...rest
}, ref) => {
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (propsChecked !== checked && propsChecked !== undefined) {
      setChecked(propsChecked);
    }
  }, [propsChecked]);

  const toggleCheck = () => {
    const newChecked = !checked;
    setChecked(newChecked);
    callBack && callBack(newChecked);
  };

  const classes = [disabled && "ta-is-disabled", className]
    .filter(Boolean)
    .join(" ");

  return (
    <Button
      ref={ref}
      icon
      symbol={checked ? "check_box" : "check_box_outline_blank"}
      onClick={(e) => {
        if (e && e.stopPropagation) e.stopPropagation();
        toggleCheck();
        onClick && onClick(e);
      }}
      disabled={disabled}
      className={classes}
      text={checked.toString()}
      {...rest}
    />
  );
});

export default CheckBox;
